/**
 * modes/studio-mode.js
 * Quản lý khởi tạo, hiển thị và dọn dẹp Avatar chính trong chế độ Studio 360.
 */

import { BlockyAvatar } from '../../avatars/blocky-avatar.js';

export function setupStudioAvatar(presetKey, customProps = {}, state, updateReactionsCb = null) {
  clearAvatars(state);

  state.activeCustomProps = {
    ...state.activeCustomProps,
    ...customProps,
    isArticulated: state.isArticulatedRig
  };

  const avatar = new BlockyAvatar(presetKey, state.activeCustomProps);
  avatar.root.position.set(0, 0.08, 0);
  state.scene.add(avatar.root);
  state.activeAvatars.push(avatar);
  state.mainAvatar = avatar;

  avatar.playAction(state.currentAction);

  if (typeof updateReactionsCb === 'function') {
    updateReactionsCb(presetKey);
  }

  return avatar;
}

export function clearAvatars(state) {
  if (state.activeAvatars) {
    state.activeAvatars.forEach((av) => {
      if (av.walkerController) {
        av.walkerController = null;
      }
      if (av.root?.parent) {
        av.root.parent.remove(av.root);
      } else if (av.root) {
        state.scene.remove(av.root);
      }
      av.dispose();
    });
  }
  state.activeAvatars = [];
  state.mainAvatar = null;
  state.secondaryAvatars = [];
  state.projectPets = [];
  state.currentAnimal = null;
}
